<!-- eslint-disable max-len -->
<route>
{
  "meta": {
    "chunkName": "misc",
    "customSite": true
  }
}
</route>

<template>
  <div class=" pb-20 pt-20 max-w-screen-xl mx-auto">
    <home-pricing-table/>
  </div>
</template>

<script>
import HomePricingTable from '../components/Home/HomePricingTable.vue';

export default {
  components: { HomePricingTable },
  name: 'Pricing',
  layout: 'default',
};
</script>

<style>
</style>
